const specs = {
  width: 620,
  title: {
    update: 'pages.condition.modal.update.single.title',
    create: 'pages.condition.modal.create.single.title'
  },
  okText: {
    update: 'pages.condition.modal.update.single.okText',
    create: 'pages.condition.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.condition.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.condition.fields.name.title',
        required: 'pages.condition.fields.name.requiredMessage',
        placeholder: 'pages.condition.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
